module.exports = __webpack_public_path__ + "static/img/two.ee34baa4.png";